module.exports = __webpack_public_path__ + "img/2_201.eca3cdce.png";